import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const FeatureList = styled('ul')(css`
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
`);

export const FeatureListItem = styled('li')(css`
    margin: 0;
    padding: 0;
`);
